<template>
    <div class="form-field form-field__bool form-field__radio" :class="rootClasses">
        <span class="form-field--title-label" v-if="label" v-html="label"/>
        <div class="form-field--row">
            <div class="form-field--input-container" v-for="item in uniqueItems" :key="item.id">
                <input type="radio"
                        class="form-field--input"
                        v-bind="getInputAttrs(item)"
                        v-model="model"
                        :value="item.val">
                <label class="form-field--label-wrap" :for="item.id">
                    <span class="form-field--box">
                        <span class="form-field--box-icon"/>
                    </span>
                    <span class="form-field--label" v-html="item.label"/>
                </label>
            </div>
        </div>
        <form-field-messages
                :messages="messages"
                :active-item="activeItem"/>
    </div>
</template>

<script>
    import FormFieldMessages from 'framework/components/form/form-field-messages/form-field-messages';
    import formFieldAbstractMixin from 'framework/mixins/form/form-field-abstract';
    import formFieldItemsMixin from 'framework/mixins/form/form-field-items';
    import formFieldBoolMixin from 'framework/mixins/form/form-field-bool';


    export default {
        components: {
            FormFieldMessages,
        },
        mixins: [
            formFieldAbstractMixin,
            formFieldItemsMixin,
            formFieldBoolMixin,
        ],
        props: {
            value: {
                type: [Number, String],
                required: true,
            },
            /** @type {IFieldItem[]} */
            items: {
                type: Array,
                required: true,
            },
            /** @type {IFormFieldState} */
            state: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
    };
</script>
